<template>
  <section v-if="authenticatedUser"  class="mt-3">
    <div>
      <div class="mb-3">
        <MembersList :groups="groups" id="my-groups-list"></MembersList>
      </div>
    </div>
    <div class="overflow-auto" v-if="showPagination">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.totalCount"
        :per-page="pagination.pageSize"
        first-text="First"
        prev-text="Prev"
        next-text="Next"
        last-text="Last"
        align="center"
        @input="getGroups">
      </b-pagination>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import MembersList from './MembersList'
import axios from 'axios'

export default {
  name: 'MembersSection',
  components: {
    MembersList
  },
  data () {
    return {
      groups: [],
      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 8
      }
    }
  },
  created () {
    // Load groups only if user is logged in
    if (this.authenticatedUser) {
      // Get my groups
      this.getGroups()
    }
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ]),
    showPagination: function () {
      return this.pagination.totalCount > this.pagination.pageSize
    }
  },
  methods: {
    initGroups: function () {
      this.groups = []
    },
    getGroups: function () {
      // Fetch a list of the groups I am member of
      console.log('33')
      let params = {
        group: 25,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize
      }
      let templist = []
      axios.get('/group/' + this.$route.params.id + '/members?start=' + params.start + '&count=' + params.count + '&includeUnconfirmed=false', {withCredentials: true})
        .then(response => {
          console.log(response.data)
          console.log('34')
          for (let i = 0; i < response.data.length; i++) {
            templist.push({'id': response.data[i].userId, 'name': response.data[i].login,
             'creator': response.data[i].group.creator.login })
          }

          this.groups = templist
          console.log(templist)

          this.groups = templist
        })
        .catch((error) => {
          console.info(error)
        })
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/groups/MembersSection.vue